// extracted by mini-css-extract-plugin
module.exports = {"ContentWrapper":"ContentWrapper_ContentWrapper__3sRAY"};